import styled from 'styled-components';

// Fills whatever box it is placed in; the viewBox stretches to it. The fill
// follows `currentColor`, so each track picks the colour by setting `color`.
export const StyledWaveform = styled.svg`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;

  path {
    fill: currentColor;
  }
`;
